import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import { Send, MapPin, Mail, Phone, Clock, Instagram, Linkedin, Twitter, MessageCircle, User, MessageSquare } from 'lucide-react';
import 'aos/dist/aos.css';
import './ContactView.css';
import StarTrail from '../components/ui/StarTrail';
import { useRef } from 'react';

const ContactView = () => {
  const contactRef = useRef(null);
  useEffect(() => {
    AOS.init({ duration: 1000 });
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    hp: '' //honepot
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    message: false
  });

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  console.log("FormData:", formData);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {
    name: formData.name.trim() === '',
    email: formData.email.trim() === '',
    message: formData.message.trim() === ''
  };
  setErrors(newErrors);

  if (Object.values(newErrors).some(Boolean)) {
    const firstErrorField = Object.keys(newErrors).find((k) => newErrors[k]);
    document.getElementById(firstErrorField)?.focus();
    return;
  }

  setToastMessage("Enviando mensaje...");
  setShowToast(true);
  setIsSending(true);

  try {
    const payload = JSON.stringify({
      name: formData.name,
      email: formData.email,
      message: formData.message,
      hp: formData.hp || '' // honeypot
    });

    const res = await fetch('/api/contacto', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: payload
    });

    const data = await res.text();
    if (!res.ok) throw new Error(data || 'Error al enviar');

    setToastMessage("¡Mensaje enviado correctamente!");
    setFormData({ name: '', email: '', message: '', hp: '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => setShowToast(false), 4000);
  } catch (err) {
    setToastMessage("Error al enviar el mensaje. Inténtalo más tarde.");
  } finally {
    setIsSending(false);
  }
};



  return (
    <div className="contact-container" ref={contactRef}>
      <StarTrail containerRef={contactRef} />
      <div className="contact-content-wrapper">
      {/* ✅ Toast */}
      {showToast && (
        <div className="custom-toast">
          <span>{toastMessage}</span>
          <button className="toast-close" onClick={() => setShowToast(false)}>✖</button>
        </div>
      )}

      <div className="contact-header" data-aos="fade-up">
        <h1 className="contact-title-main" style={{ marginTop: '-30px' }}>Queremos construir el futuro contigo.</h1>
        <p>
          ¿Tienes una idea, proyecto o curiosidad? <strong>Escríbenos.</strong>
        </p>
      </div>

      <div className="contact-form" data-aos="fade-up">
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="name" className="input-icon clickable-icon">
              <User size={20} />
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="¿Cómo te llamas?"
              className={errors.name ? 'input-error' : ''}
              value={formData.name}
              onChange={handleChange}
              required
              aria-invalid={errors.name ? 'true' : 'false'}
            />
          </div>

          <div className="input-group">
            <label htmlFor="email" className="input-icon clickable-icon">
              <Mail size={20} />
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="tucorreo@ejemplo.com"
              className={errors.email ? 'input-error' : ''}
              value={formData.email}
              onChange={handleChange}
              required
              aria-invalid={errors.email ? 'true' : 'false'}
              pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              inputMode="email"
              autoComplete="email"
            />
          </div>

          <div className="input-group">
            <label htmlFor="message" className="input-icon clickable-icon">
              <MessageSquare size={20} />
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Cuéntanos qué te interesa"
              className={errors.message ? 'input-error' : ''}
              value={formData.message}
              onChange={handleChange}
              required
              aria-invalid={errors.message ? 'true' : 'false'}
              rows={5}
            />
          </div>

          {/* Honeypot oculto */}
          <input
            type="text"
            name="hp"
            value={formData.hp}
            onChange={handleChange}
            tabIndex={-1}
            autoComplete="off"
            style={{ display: 'none' }}
            aria-hidden="true"
          />

          <div className="contact-btn-container">
            <button 
              type="submit" 
              disabled={isSending}
              className="contact-submit-btn"
            >
              {isSending ? 'Enviando...' : 'Enviar'}
              <Send size={18} />
            </button>
          </div>
        </form>

      </div>
      

      <div className="contact-icons" data-aos="fade-up">
        <a href="mailto:info@sparklingtech.es" target="_blank" rel="noopener noreferrer">
          <Mail size={24} />
        </a>
        <a href="https://www.linkedin.com/company/sparklingtechsolutions/" target="_blank" rel="noopener noreferrer">
          <Linkedin size={24} />
        </a>
        <a href="https://wa.me/34680339168" target="_blank" rel="noopener noreferrer">
          <MessageCircle size={24} />
        </a>
        <a href="tel:+34680339168">
          <Phone size={24} />
        </a>
      </div>

      {/* Frase eliminada a petición del usuario */}

      </div>
    </div>
  );
};

export default ContactView;
